import axios, { AxiosResponse } from "axios";

class Service {
    public async GetLogs(): Promise<AxiosResponse<any[]>> {
        return axios.get('api/log/');
    }
    public async GetLogsPaged(data: any): Promise<AxiosResponse<any[]>> {
        return axios.post('api/log/GetLogsPaged', data);
    }
    public async GetLogType(id: number): Promise<AxiosResponse<any>> {
        return axios.get(`api/log/${id}`);
    }
}

export const LogService: Service = new Service();
